export const appleDRM = ['com.apple.fps.1_0', 'com.apple.fps.2_0'];
export const openDRM = ['com.widevine.alpha', 'com.microsoft.playready'];
export var DRM_TYPES;
(function (DRM_TYPES) {
    DRM_TYPES["FAIRPLAY"] = "fairplay";
    DRM_TYPES["WIDEVINE"] = "widevine";
    DRM_TYPES["PLAYREADY"] = "playready";
})(DRM_TYPES || (DRM_TYPES = {}));
export var STREAM_TYPES;
(function (STREAM_TYPES) {
    STREAM_TYPES["DASH"] = "dash";
    STREAM_TYPES["HLS"] = "hls";
})(STREAM_TYPES || (STREAM_TYPES = {}));
